module.exports = __webpack_public_path__ + "f64feddd5dfe6f0d73a751160d17c0af.png";